import React, { useLayoutEffect } from 'react'
import { Helmet } from 'react-helmet'

import { Intro } from './intro'
import { Compare } from './compare'
import { Process } from './process'
import { Extras } from './extras'
import { ServicesCta } from './cta'

// /services, rebuilt on the design system the home page moved onto on
// 4 October 2026. Read client/gwmc/DESIGN.md before touching any of it.
//
// This file is a running order and nothing else, the way
// pages/home/home-page.jsx is. One section is one directory and one job, each
// owning its own markup, copy and stylesheet.
//
//   section   directory    band    job
//   --------------------------------------------------------------------
//   Intro     ./intro/     paper   the H1, the promise, the facts line
//   Compare   ./compare/   paper   all six washes, honestly, side by side
//   Extras    ./extras/    stone   the 21 add-ons, grouped and priced
//   Cta       ./cta/       paper   the one filled button, and the surcharges
//
// Paper, paper, stone, paper. Two paper bands in a row at the top is the same
// pattern the home page ends on (areas then the final CTA): the comparison is
// the page's content and it reads best on the same ground the headline sits
// on, and the one stone band is what separates the washes from the add-ons.
//
// THE PAGE'S RELATIONSHIP TO THE HOME PAGE. The home page's whats-included
// section answers "which of the three do I want". This page answers "show me
// everything and let me compare", and whats-included links here saying so.
// The two share one row vocabulary: the lists in compare/washes.js and the
// lists in pages/home/sections/whats-included/index.js are the same rows in
// the same words, and the first three columns here are the three cards there.
//
// WHAT THE REBUILD DELETED:
//
//   services-plans/   the six-colour comparison matrix, its "Popular" ribbon,
//                     its react-slick phone carousel and both slick
//                     stylesheets. react-slick and slick-carousel are now
//                     unimported anywhere in the bundle.
//   services-bricks/  the stock photograph collage behind the old H1.
//   book-valet/       the navy full-bleed CTA band with the SVG triangle.
//   services-extra/   the four flat add-on cards and the "Save £X" badge.
//
// The three stylesheets those components used (assets/styles/services_*.css
// and book_valet.css) are now unreferenced, and assets/styles/home.css still
// @imports them. Removing those three @import lines is outside this slot's
// scope and is in the build report, along with dropping react-slick and
// slick-carousel from package.json.
export const ServicesPage = React.memo(() => {
  useLayoutEffect(() => {
    // /services#extras is the Washes menu's "All add-ons": the section is
    // only in the document once React has drawn it, so go to it now.
    const target = window.location.hash && document.getElementById(window.location.hash.slice(1))
    if (target) target.scrollIntoView()
    else window.scrollTo(0, 0)
  }, [])

  return (
    <div className="home">
      <Helmet title="Mobile car wash prices &amp; services in London | GoWashMyCar" />

      <Intro />
      <Compare />
      <Process />
      <Extras />
      <ServicesCta />
    </div>
  )
})
